import React from 'react';
import { ListItemContainer, Rectangle } from './ListLoader.styled';

export const ListItemLoader = (props) => (
  <ListItemContainer>
    <Rectangle height={10} {...props} />
  </ListItemContainer>
);

export const ListTitleLoader = () => (
  <ListItemContainer>
    <Rectangle height={16} width={160} opacity={0.7} />
  </ListItemContainer>
);

export const ListLoader = () => (
  <React.Fragment>
    <ListTitleLoader />
    <ListItemLoader width={140} opacity={0.6} />
    <ListItemLoader width={100} opacity={0.5} />
    <ListItemLoader width={106} opacity={0.4} />
    <ListItemLoader width={82} opacity={0.3} />
  </React.Fragment>
);
